import { RxJsonSchema, RxDocument } from 'rxdb';
import { RolePermissionViewRec } from '../models/role-permission-view-rec'

export const rolePermissionViewMethods = {

}

export type RolePermissionViewDoc = RxDocument<RolePermissionViewRec,typeof rolePermissionViewMethods>

export const rolePermissionViewSchema: RxJsonSchema<RolePermissionViewRec> = {
    title: 'role permission view schema',
    version: 1,
    keyCompression: false,
    type: 'object',
    properties: {
        id: {
            type: 'string',
            primary: true
        },
        roleId: { type: 'string' },
        roleName: { type: 'string' },
        permissionId: { type: 'string' },
        permissionName: { type: 'string' },
        updatedAt: { type: 'number' }
    },
    indexes: []
};

export const rolePermissionViewPullQueryBuilder = () => {
    const query = 'query FeedForRxdbRolePermissionViewRecs($lastId: String!, $minUpdatedAt: Float! ){ '+
    'feedForRxdbRolePermissionViewRecs(lastId: $lastId, minUpdatedAt: $minUpdatedAt ) { ' + 
        'id roleId roleName permissionId permissionName updatedAt deleted _rev'
    + '}}';

    return (doc : RolePermissionViewRec) => {
        const rtn = {
            query,
            variables: {
                lastId: !doc ? '' : doc.id,
                minUpdatedAt: !doc ? 0 : doc.updatedAt
            }
        };
        //console.log(`pathViewPullQueryBuilder() updatedAt=${doc?.updatedAt}`);console.dir(rtn)
        return rtn
    };

};

